"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleRecaptchaV3 = void 0;
class GoogleRecaptchaV3 {
    constructor(siteKey) {
        this.siteKey = siteKey;
    }
    // https://developers.google.com/recaptcha/docs/v3
    bind() {
        return __awaiter(this, void 0, void 0, function* () {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = `https://www.google.com/recaptcha/api.js?render=${this.siteKey}`;
            return new Promise((resolve, reject) => {
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        });
    }
    // https://developers.google.com/recaptcha/docs/v3#programmatically_invoke_the_challenge
    getToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                grecaptcha.ready(() => {
                    grecaptcha
                        .execute(this.siteKey, { action: 'submit' })
                        .then(token => resolve(token))
                        .catch(reject);
                });
            });
        });
    }
}
exports.GoogleRecaptchaV3 = GoogleRecaptchaV3;
